import { USER_ROLES } from 'cpool-constants';
import { z } from 'zod';

import { schemaUserCommon } from './userCommon';

export const schemaAdmin = z
    .object({ role: z.literal(USER_ROLES.admin) })
    .merge(schemaUserCommon.omit({ procheckId: true }));
